import React from 'react'
import { FaExclamationCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export const NotFound = () => {
    
return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-b from-navy-900 to-navy-700 text-white">
      <div className="text-7xl text-red-500">
        <FaExclamationCircle />
      </div>
      <h1 className="text-4xl mt-6 font-extrabold">404 - Page Not Found</h1>
      <p className="text-xl mt-4">
        Oops! It looks like the page you are looking for does not exist.
      </p>


      {/* <Link
        to="/"
        className="mt-8 bg-blue-900 hover:bg-blue-700 text-white py-3 px-3 rounded-none font-bold transition-transform transform hover:scale-105 hover:rotate-2 shadow-lg"
      >
        Go back to the homepage
      </Link> */}

    </div>
  );
}
